export enum PlatformEnum {
  PRM = 0,
  MyCim = 1,
}
